// extracted by mini-css-extract-plugin
export default {"canNotVoteButton":"EntryDetails_canNotVoteButton__aOLoZ","wrapper":"EntryDetails_wrapper__nVcKP","edClipboardButton":"EntryDetails_edClipboardButton__hz8cV"};